module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_oval_brown.40967677.png";